/**
 * CSK Invariant Lifecycle Governance Demo — application shell.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

import { createMonographRouteApp } from "../MonographRouteApp.js";
import { NAVIGATION } from "./data/nav.js";
import { panelTokens } from "@csk/demo-ui";

export const App = createMonographRouteApp({
  navigation: NAVIGATION,
  theme: panelTokens,
  surfaceTokenPrefix: "ilg",
  slug: "invariant-lifecycle-governance",
  title: "Invariant Lifecycle Governance",
  eyebrow: "Invariant Lifecycle Governance",
  tagline: "Equivalence does not authorize. Past proof does not future-prove.",
  companionPath: "theory/manuscripts/contrib/InvariantLifecycleGovernance/",
  mainRegionId: "ilg-main",
  shortcutsTitle: "ILG shortcuts",
  backgroundColor: "#0a1424",
});
